import { render, staticRenderFns } from "./SelfAttendance.vue?vue&type=template&id=213c5166&scoped=true&"
import script from "./SelfAttendance.vue?vue&type=script&lang=js&"
export * from "./SelfAttendance.vue?vue&type=script&lang=js&"
import style0 from "./SelfAttendance.vue?vue&type=style&index=0&id=213c5166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c5166",
  null
  
)

export default component.exports